function parseJSON(value, fallback) {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

function isoDate(year, monthIndex, day) {
  const month = String(monthIndex + 1).padStart(2, '0');
  const date = String(day).padStart(2, '0');
  return `${year}-${month}-${date}`;
}

function todayISO() {
  const now = new Date();
  return isoDate(now.getFullYear(), now.getMonth(), now.getDate());
}

function bootEvents(root) {
  if (!root || root.dataset.booted === '1') return;
  root.dataset.booted = '1';

  const copy = parseJSON(root.querySelector('[data-events-copy]')?.textContent, {});
  const limited = new Set(parseJSON(root.dataset.limited || '[]', []));
  const months = parseJSON(root.dataset.months || '[]', []);
  const weekdays = parseJSON(root.dataset.weekdays || '[]', ['M', 'T', 'W', 'T', 'F', 'S', 'S']);
  const paletteMax = Number(root.dataset.paletteMax || 3);
  const waNumber = String(root.dataset.whatsapp || '').replace(/\D/g, '');
  const waPrefix = root.dataset.waPrefix || 'Artink event brief';

  const cal = root.querySelector('[data-events-cal]');
  const monthLabel = root.querySelector('[data-events-month]');
  const prevBtn = root.querySelector('[data-events-prev]');
  const nextBtn = root.querySelector('[data-events-next]');
  const guests = root.querySelector('[data-events-guests]');
  const sendBtn = root.querySelector('[data-events-send]');

  const out = {
    heading: root.querySelector('[data-brief-heading]'),
    date: root.querySelector('[data-brief-date]'),
    venue: root.querySelector('[data-brief-venue]'),
    guests: root.querySelector('[data-brief-guests]'),
    budget: root.querySelector('[data-brief-budget]'),
    palette: root.querySelector('[data-brief-palette]'),
    swatches: root.querySelector('[data-brief-swatches]'),
    note: root.querySelector('[data-brief-note]'),
  };

  const now = new Date();
  const minMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  let view = new Date(now.getFullYear(), now.getMonth(), 1);

  const brief = {
    fn: root.querySelector('.artink-events__fn[aria-pressed="true"]')?.dataset.name || '',
    price: root.querySelector('.artink-events__fn[aria-pressed="true"]')?.dataset.price || '',
    date: null,
    iso: null,
    limited: false,
    ven: root.querySelector('.artink-events__chip[data-group="venue"][aria-pressed="true"]')?.textContent.trim() || '',
    gst: guests?.value || '',
    bud: root.querySelector('.artink-events__chip[data-group="budget"][aria-pressed="true"]')?.textContent.trim() || '',
    pal: [],
  };

  root.querySelectorAll('.artink-events__pal[aria-pressed="true"]').forEach((button) => {
    if (brief.pal.length >= paletteMax) return;
    brief.pal.push({
      n: button.dataset.name,
      g: button.querySelector('.artink-events__sw')?.style.background || '',
    });
  });

  function setPressed(buttons, active) {
    buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button === active));
    });
  }

  function render() {
    if (out.heading) out.heading.textContent = brief.fn || copy.emptyFunction || 'Event';
    if (out.date) out.date.textContent = brief.date || copy.emptyDate || 'Not chosen';
    if (out.venue) out.venue.textContent = brief.ven || copy.emptyVenue || 'Not chosen';
    if (out.guests) out.guests.textContent = brief.gst || '—';
    if (out.budget) out.budget.textContent = brief.bud || copy.emptyBudget || 'Not chosen';
    if (out.palette) {
      out.palette.textContent = brief.pal.length
        ? brief.pal.map((item) => item.n).join(', ')
        : copy.emptyPalette || 'Not chosen';
    }
    if (out.swatches) {
      out.swatches.replaceChildren();
      brief.pal.forEach((item) => {
        const swatch = document.createElement('i');
        swatch.style.background = item.g;
        out.swatches.appendChild(swatch);
      });
    }
    if (out.note) {
      out.note.className = 'artink-events__note';
      if (!brief.date) {
        out.note.textContent = copy.notePick || 'Pick a date for your event.';
      } else if (brief.limited) {
        out.note.classList.add('artink-events__note--warn');
        out.note.textContent = (copy.noteLimited || 'Busy day on {date} — still open for another order.').replace(
          '{date}',
          brief.date
        );
      } else {
        out.note.classList.add('artink-events__note--ok');
        out.note.textContent = (copy.noteOk || 'Great — {date} works. Send the brief and you’ll have a costed quote in 48 hours.').replace(
          '{date}',
          brief.date
        );
      }
    }
  }

  function drawCal() {
    if (!cal) return;
    const year = view.getFullYear();
    const month = view.getMonth();
    if (monthLabel) {
      monthLabel.textContent = `${months[month] || ''} ${year}`.trim();
    }
    if (prevBtn) prevBtn.disabled = view <= minMonth;

    cal.replaceChildren();
    weekdays.forEach((label) => {
      const el = document.createElement('span');
      el.className = 'artink-events__dow';
      el.textContent = label;
      cal.appendChild(el);
    });

    const first = (new Date(year, month, 1).getDay() + 6) % 7;
    const days = new Date(year, month + 1, 0).getDate();
    const today = todayISO();

    for (let i = 0; i < first; i += 1) {
      const pad = document.createElement('span');
      pad.className = 'artink-events__pad';
      cal.appendChild(pad);
    }

    for (let day = 1; day <= days; day += 1) {
      const iso = isoDate(year, month, day);
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = String(day);
      button.dataset.iso = iso;

      const isPast = iso < today;
      const isLimited = limited.has(iso);
      const isToday = iso === today;

      // Only past days are blocked — multiple orders can share a future date.
      if (isPast) {
        button.disabled = true;
        button.title = copy.pastLabel || 'Past';
      } else {
        if (isToday) button.classList.add('artink-events__day--today');
        if (isLimited) {
          button.classList.add('artink-events__day--lim');
          button.title = copy.limitedLabel || 'Popular date — still open';
        }
      }

      button.setAttribute('aria-pressed', String(brief.iso === iso));
      button.addEventListener('click', () => {
        if (button.disabled) return;
        cal.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        brief.iso = iso;
        brief.date = `${day} ${months[month] || ''} ${year}`.replace(/\s+/g, ' ').trim();
        brief.limited = isLimited;
        render();
      });
      cal.appendChild(button);
    }
  }

  root.querySelectorAll('.artink-events__fn').forEach((button) => {
    button.addEventListener('click', () => {
      setPressed(root.querySelectorAll('.artink-events__fn'), button);
      brief.fn = button.dataset.name || button.textContent.trim();
      brief.price = button.dataset.price || '';
      render();
    });
  });

  root.querySelectorAll('.artink-events__chip[data-group="venue"]').forEach((button) => {
    button.addEventListener('click', () => {
      setPressed(root.querySelectorAll('.artink-events__chip[data-group="venue"]'), button);
      brief.ven = button.textContent.trim();
      render();
    });
  });

  root.querySelectorAll('.artink-events__chip[data-group="budget"]').forEach((button) => {
    button.addEventListener('click', () => {
      setPressed(root.querySelectorAll('.artink-events__chip[data-group="budget"]'), button);
      brief.bud = button.textContent.trim();
      render();
    });
  });

  root.querySelectorAll('.artink-events__pal').forEach((button) => {
    button.addEventListener('click', () => {
      const on = button.getAttribute('aria-pressed') === 'true';
      if (!on && brief.pal.length >= paletteMax) return;
      button.setAttribute('aria-pressed', String(!on));
      const name = button.dataset.name;
      const gradient = button.querySelector('.artink-events__sw')?.style.background || '';
      if (on) {
        brief.pal = brief.pal.filter((item) => item.n !== name);
      } else {
        brief.pal.push({ n: name, g: gradient });
      }
      render();
    });
  });

  guests?.addEventListener('input', () => {
    brief.gst = guests.value || '—';
    render();
  });

  prevBtn?.addEventListener('click', () => {
    const next = new Date(view.getFullYear(), view.getMonth() - 1, 1);
    if (next < minMonth) return;
    view = next;
    drawCal();
  });

  nextBtn?.addEventListener('click', () => {
    view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
    drawCal();
  });

  // The brief as a WhatsApp message: greeting, bold title (*...*), one line per choice, page link.
  function briefMessage() {
    const notChosen = copy.emptyDate || 'Not chosen';
    const fn = brief.fn ? (brief.price ? `${brief.fn} (${brief.price})` : brief.fn) : notChosen;
    const lines = [
      copy.waGreeting || "Hi Artink! I'd like a quote for this event:",
      '',
      `*${waPrefix}*`,
      `• ${copy.labelFunction || 'Function'}: ${fn}`,
      `• ${copy.labelDate || 'Date'}: ${brief.date || notChosen}${brief.limited ? ' (popular date)' : ''}`,
      `• ${copy.labelVenue || 'Venue'}: ${brief.ven || copy.emptyVenue || notChosen}`,
      `• ${copy.labelGuests || 'Guests'}: ${brief.gst || notChosen}`,
      `• ${copy.labelBudget || 'Budget'}: ${brief.bud || copy.emptyBudget || notChosen}`,
      `• ${copy.labelPalette || 'Palette'}: ${
        brief.pal.length ? brief.pal.map((item) => item.n).join(', ') : copy.emptyPalette || notChosen
      }`,
      '',
      window.location.href.split('#')[0],
    ];
    return lines.join('\n');
  }

  // Phones get a same-tab navigation (it hands off to the WhatsApp app and is never treated as
  // a popup, even in Instagram/Facebook browsers); desktops open WhatsApp Web in a new tab.
  function openWhatsApp(url) {
    if (window.matchMedia('(pointer: coarse)').matches) {
      window.location.href = url;
      return;
    }
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  sendBtn?.addEventListener('click', () => {
    if (!waNumber) {
      console.warn('[artink-events] Add a WhatsApp number in the section settings.');
      return;
    }
    openWhatsApp(`https://wa.me/${waNumber}?text=${encodeURIComponent(briefMessage())}`);
  });

  drawCal();
  render();

  root._artinkEventsCleanup = () => {
    root.dataset.booted = '0';
  };
}

function initAll() {
  document.querySelectorAll('[data-artink-events]').forEach(bootEvents);
}

initAll();
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-artink-events]').forEach(bootEvents);
});
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-artink-events]').forEach((root) => {
    root._artinkEventsCleanup?.();
  });
});
